export type LeaderboardContextType = 'daily' | 'quiz' | 'weekly';
export type LeaderboardScope = 'friends' | 'board' | 'all';

export interface ActivityLeaderboardInput {
  contextType: LeaderboardContextType;
  dailyChallengeId?: string | null;
  quizId?: string | null;
  editionId?: string | null;
  scope: LeaderboardScope;
  boardId?: string | null;
  viewerUserId: string;
  viewerIsAnonymous: boolean;
  l1TagSlug?: string | null;
  weekStart?: string | null;
  partnerId?: string | null;
  limit?: number;
  offset?: number;
}

export interface WeeklyLeaderboardWindowInput extends ActivityLeaderboardInput {
  sessionXP: number;
  startRank?: number | null;
  endRank?: number | null;
  before?: number;
  after?: number;
}

export type ActivityLeaderboardWindowInput = Omit<WeeklyLeaderboardWindowInput, 'sessionXP'>;
type LeaderboardWindowKeyInput = ActivityLeaderboardWindowInput & { sessionXP?: number };

export const socialLeaderboardKeys = {
  all: ['socialLeaderboards'] as const,
  profile: (userId: string | null, isAnonymous: boolean) =>
    [...socialLeaderboardKeys.all, 'profile', userId, isAnonymous] as const,
  boards: (userId: string | null, isAnonymous: boolean) =>
    [...socialLeaderboardKeys.all, 'boards', userId, isAnonymous] as const,
  leaderboard: (input: Omit<ActivityLeaderboardInput, 'limit' | 'offset'>) =>
    [
      ...socialLeaderboardKeys.all,
      'activity',
      input.contextType,
      input.dailyChallengeId ?? null,
      input.quizId ?? null,
      input.editionId ?? null,
      input.scope,
      input.boardId ?? null,
      input.l1TagSlug ?? null,
      input.weekStart ?? null,
      input.partnerId ?? null,
      input.viewerUserId,
      input.viewerIsAnonymous,
    ] as const,
  leaderboardWindow: (
    input: Omit<LeaderboardWindowKeyInput, 'limit' | 'offset' | 'startRank' | 'endRank'>
  ) =>
    [
      ...socialLeaderboardKeys.all,
      'rankWindow',
      input.contextType,
      input.dailyChallengeId ?? null,
      input.quizId ?? null,
      input.editionId ?? null,
      input.scope,
      input.boardId ?? null,
      input.l1TagSlug ?? null,
      input.weekStart ?? null,
      input.partnerId ?? null,
      input.viewerUserId,
      input.viewerIsAnonymous,
      input.sessionXP,
      input.before ?? 10,
      input.after ?? 10,
    ] as const,
};
